<template>
  <CrudList title="Usuarios" storeName="Users_scroll" labelAddNew="Agregar nuevo usuario"
    descriptionDeleted="Se eliminarán también los spots y autos del usuario. Está seguro que quiere continuar?"
    labelModalConfirm="Si" labelModalCancel="No" slot-scope="{ item }" sortable next-link="/admin/user_enterprises" :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '#'
      },
      {
        text: 'Usuarios',
        disabled: true,
        href: '/admin/users_scroll'
      }
    ]" canSearch :canExport="true" :canRefundCoins="true" :filters="options">
    <template v-slot:head_item>
      <v-select v-model="options.type" label="Segmento" :items="types" class="select-search max-w-270" solo
        elevation="0" dense hide-details append-icon="$caretDownIcon">
        <!-- <template #append>
          <v-icon >$caretUp</v-icon>
        </template> -->
        <template slot="no-data">
          <v-alert :value="true">There is no info to show</v-alert>
        </template>
      </v-select>
    </template>
    <template v-slot:name="{ item }">
      <div class="fonts-500">{{ item.name }}</div>
    </template>
    <template v-slot:last_name="{ item }">
      <div class="fonts-500">{{ item.last_name }}</div>
    </template>
    <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt="" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>

    <template v-slot:rent_orders="{ item }">

      <v-btn elevation="0" class="btn-status-color btn-uppercase fonts-s12" :class="`${getButtonStyle(item)}`"
        @click="$router.push('/admin/users_scroll/' + item.id + '/rent_orders')">
        Estadias
      </v-btn>
    </template>

    <template v-slot:spots="{ item }">
      <v-btn elevation="0" class="btn-status-color btn-uppercase fonts-s12"
        :color="item.color_spot ? (color_status[item.color_spot] || 'btn-status-color-blue') : 'btn-status-color-blue'"
        @click="$router.push('/admin/users_scroll/' + item.id + '/spots')">
        Spots
      </v-btn>
    </template>

    <template v-slot:cars="{ item }">
      <v-btn elevation="0" class="btn-status-color btn-uppercase fonts-s12"
        :color="item.color_car ? (color_status[item.color_car] || 'btn-status-color-blue') : 'btn-status-color-blue'"
        @click="$router.push('/admin/users_scroll/' + item.id + '/cars')">
        Autos
      </v-btn>
    </template>
    <template v-slot:created_at="{ item }">
      {{ formatDate(item.created_at) }}
    </template>
  </CrudList>
</template>
<script>
import { mapState } from "vuex";
import CrudList from "@/components/Crud/CrudListScroll";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudList },
  computed: {
    ...mapState({
      color_spots: (state) => state.Spots.colors,
      color_cars: (state) => state.Cars.colors,
    }),
  },
  data() {
    return {
      options: {
        type: ''
      },
      types: [
        {
          text: "Spot no verificado",
          value: "spot_no_verf",
        },
        {
          text: "Spot verificado sin constancia de domicilio",
          value: "spot_verf_sin_const",
        },
        {
          text: "Spot verificado con constancia de domicilio",
          value: "spot_verf_con_const",
        },
        {
          text: "Con estadias",
          value: "con_estadias",
        },
        {
          text: "Sin estadias",
          value: "sin_estadias",
        },
        {
          text: "Con autos",
          value: "user_with_car_and_spot",
        },
        {
          text: "Sin autos",
          value: "user_without_car_and_spot",
        },
      ],
      color_status: {
        green: "btn-status-color-green",
        primary: "btn-status-color-blue",
        grey: "btn-status-color-black",
        yellow: "btn-status-color-yellow",
        red: "btn-status-color-orange",
      }
    }
  },
  methods: {
    getButtonStyle(item) {
      if (!item.color_rend_spot) {
        return {}
      }
      let status_color = 'btn-status-color-blue'
      switch (item.color_rend_spot) {
        case 'success':
          status_color = 'btn-status-color-green'
          break
        case 'danger':
          status_color = 'btn-status-color-orange'
          break
      }
      return status_color
    }


  }

};
</script>
